import { render, staticRenderFns } from "./purchaseSubmenu.vue?vue&type=template&id=051df4e0&"
import script from "./purchaseSubmenu.vue?vue&type=script&lang=ts&"
export * from "./purchaseSubmenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports